import React, {useState} from 'react';
import {calculateAge, putDataIntoDataLayer, detectBtagPromocodeFromQS, getCookie} from '../utils';
import {
    REGEX_ONLY_LETTERS,
    COOKIES, FORM_CONSTRAINTS,
    REGEX_BTAG_ONLY_DIGITS
} from '../constants';
import {
    BIRTHDATE_ENTER_VALID, BIRTHDATE_OVER_18,
    EMAIL_CANT_BE_EMPTY, EMAIL_INVALID_FORMAT,
    FIRST_NAME_CANT_BE_EMPTY,
    FIRST_NAME_NOT_ALLOW, FIRST_NAME_SAME_TO_SURNAME,
    FIRST_NAME_SHOULD_BE_BETWEEN,
    SURNAME_CANT_BE_EMPTY,
    SURNAME_NOT_ALLOW,
    SURNAME_SHOULD_BE_BETWEEN,
} from '../constants/errorMessagesConstants';
import Selectors from "../selectors";
import {connect} from "react-redux";
import {
    resetPromocodeAction,
    updateBirthdayDataAction,
    updateEmailDataAction,
    updateFirstNameDataAction,
    updateGtmRegistrationFirstInteractionSentAction,
    updateSurnameDataAction,
    validatePromocodeAction,
    validateStep1Action,
    updateBtagAsSiteIdAction
} from "../state/registration";
import {isValidDate} from "../utils";

const stateToProps = (state) => ({
    currentPage: Selectors.getCurrentPage(state),
    emailData: Selectors.getEmailData(state),
    firstNameData: Selectors.getFirstNameData(state),
    surnameData: Selectors.getSurnameData(state),
    birthdayData: Selectors.getBirthdayData(state),
    promocodeData: Selectors.getPromocodeData(state),
    isPromocodeInQueryString: Selectors.isPromocodeInQueryString(state),
    isLoading: Selectors.getIsLoadingStep1(state),
    isDesktop: Selectors.isDesktop(state),
    gtmRegistrationFirstInteractionSent: Selectors.getGtmRegistrationFirstInteractionSent(state),
    gtmRegistrationStartSent: Selectors.getGtmRegistrationStartSent(state),
});

const actionsToProps = (dispatch) => ({
    updateEmailData: (data) => dispatch(updateEmailDataAction(data)),
    updateFirstNameData: (data) => dispatch(updateFirstNameDataAction(data)),
    updateSurnameData: (data) => dispatch(updateSurnameDataAction(data)),
    updateBirthdayData: (data) => dispatch(updateBirthdayDataAction(data)),
    validatePromocode: (payload) => dispatch(validatePromocodeAction(payload)),
    resetPromocode: (payload) => dispatch(resetPromocodeAction(payload)),
    validateStep1: (payload) => dispatch(validateStep1Action(payload)),
    updateGtmRegistrationFirstInteractionSent: (payload) => dispatch(updateGtmRegistrationFirstInteractionSentAction(payload)),
    updateBtagAsSiteId: (payload) => dispatch(updateBtagAsSiteIdAction(payload))
});

const useComponentDidMount = onMountHandler => {
    React.useEffect(() => {
        onMountHandler();
    }, []);
};

const FirstStep = (props) => {

    const [promocodeValue, setPromocodeValue] = useState(props.promocodeData.value);
    const [emailValue, setEmailValue] = useState(props.emailData.value);
    const [firstNameValue, setFirstNameValue] = useState(props.firstNameData.value);
    const [surnameValue, setSurnameValue] = useState(props.surnameData.value);
    const [dayValue, setDayValue] = useState(props.birthdayData.day);
    const [monthValue, setMonthValue] = useState(props.birthdayData.month);
    const [yearValue, setYearValue] = useState(props.birthdayData.year);

    useComponentDidMount(() => {
        window.scrollTo({top: 0, behavior: 'smooth'});
        detectBtagPromocodeFromQS();

        const btag = getCookie(COOKIES.BTAG);
        const promo = getCookie(COOKIES.PROMOCODE);

        if (promo !== '') {
            setPromocodeValue(promo);

            props.validatePromocode({promocode: promo, btag: btag, isInQueryString: true});
        } else if (promo === '' && btag !== '') {
            // get "a_" part of btag cookie
            const btagSplittedArray = btag.split('_');
            if (btagSplittedArray.length > 1 && REGEX_BTAG_ONLY_DIGITS.test(btag)) {
                const promocodeInBtag = btagSplittedArray[1].slice(0, -1);
                setPromocodeValue(promocodeInBtag);
                props.validatePromocode({promocode: promocodeInBtag, btag: btag, isInQueryString: true});
            }
            props.updateBtagAsSiteId({btag: btag});
        }
    });

    const checkAllStatuses = () => {
        const mailValid = props.emailData.status === 1;
        const firstNameValid = props.firstNameData.status === 1;
        const lastNameValid = props.surnameData.status === 1;
        const birthdateValid = props.birthdayData.status === 1;
        const promocodeValid = props.promocodeData.status === 1 || (props.promocodeData.status === 0 && props.promocodeData.value === '');

        return mailValid && firstNameValid && lastNameValid && birthdateValid && promocodeValid;
    };

    const onChangeEmail = e => {
        sentGtmRegistrationFirstInteraction();

        const email = e.target.value.trim();
        if (email.length <= FORM_CONSTRAINTS.email.max_length) {
            setEmailValue(email);
        }
    }

    const checkEmail = (event) => {
        const email = event.target.value.trim();

        if (email.length === 0) {
            props.updateEmailData({
                value: email,
                status: -1,
                message: EMAIL_CANT_BE_EMPTY,
            });
        } else {
            let regex = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$');
            const isEmailWellFormed = regex.test(email);

            if (!isEmailWellFormed) {
                props.updateEmailData({
                    value: email,
                    status: -1,
                    message: EMAIL_INVALID_FORMAT,
                });
            } else {
                props.updateEmailData({
                    value: email,
                    status: 1,
                    message: '',
                });
            }
        }
    };

    const onChangeFirstName = e => {
        sentGtmRegistrationFirstInteraction();

        const firstName = e.target.value.trim();
        if (firstName.length <= FORM_CONSTRAINTS.first_name.max_length) {
            setFirstNameValue(firstName);
        }
    }

    const getFirstNameValue = event => checkFirstname(event != null && event.target.value.trim());

    const checkFirstname = (firstName) => {
        let value = '';
        let message = '';
        let status = -1;

        if (firstName === '') {
            message = FIRST_NAME_CANT_BE_EMPTY;
        } else if (!REGEX_ONLY_LETTERS.test(firstName)) {
            message = FIRST_NAME_NOT_ALLOW;
            value = firstName;
        } else if (firstName.length < FORM_CONSTRAINTS.first_name.min_length || firstName.length > FORM_CONSTRAINTS.first_name.max_length) {
            message = FIRST_NAME_SHOULD_BE_BETWEEN;
            value = firstName;
        } else if (firstName === props.surnameData.value) {
            message = FIRST_NAME_SAME_TO_SURNAME;
            value = firstName;
        } else {
            value = firstName;
            status = 1;
        }

        props.updateFirstNameData({value, message, status});
    };

    const onChangeSurname = e => {
        sentGtmRegistrationFirstInteraction();

        const surname = e.target.value.trim();
        if (surname.length <= FORM_CONSTRAINTS.surname.max_length) {
            setSurnameValue(surname);
        }
    }

    const getSurnameValue = event => checkSurname(event != null && event.target.value.trim());

    const checkSurname = (surname) => {
        let value = '';
        let message = '';
        let status = -1;

        if (surname === '') {
            message = SURNAME_CANT_BE_EMPTY;
        } else if (!REGEX_ONLY_LETTERS.test(surname)) {
            message = SURNAME_NOT_ALLOW;
            value = surname;
        } else if (surname.length < FORM_CONSTRAINTS.surname.min_length || surname.length > FORM_CONSTRAINTS.surname.max_length) {
            message = SURNAME_SHOULD_BE_BETWEEN;
            value = surname;
        } else if (surname === props.firstNameData.value) {
            message = FIRST_NAME_SAME_TO_SURNAME;
            value = surname;
        } else {
            value = surname;
            status = 1;
        }

        props.updateSurnameData({value, message, status});
    };

    const getCalendarDay = event => {
        checkBirthday(
            event != null ? event.target.value.trim() : '',
            props.birthdayData.month,
            props.birthdayData.year
        );
    }

    const getCalendarMonth = event => {
        checkBirthday(
            props.birthdayData.day,
            event != null ? event.target.value.trim() : '',
            props.birthdayData.year
        );
    }

    const getCalendarYear = event => {
        checkBirthday(
            props.birthdayData.day,
            props.birthdayData.month,
            event != null ? event.target.value.trim() : ''
        );
    }

    const checkBirthday = (day, month, year) => {
        if (!isValidDate(day, month, year)) {
            props.updateBirthdayData({
                day: day,
                month: month,
                year: year,
                status: -1,
                message: BIRTHDATE_ENTER_VALID
            })
        } else {
            const age = calculateAge(day, month, year);
            if (age < 18) {
                props.updateBirthdayData({
                    day: day,
                    month: month,
                    year: year,
                    status: -1,
                    message: BIRTHDATE_OVER_18
                })
            } else {
                props.updateBirthdayData({
                    day: day,
                    month: month,
                    year: year,
                    status: 1,
                    message: ''
                })
            }
        }
    }

    const getClassesByStatus = (status) => {
        let classes = ' ';
        if (status === -1) {
            classes += ` registration-form__row--error registration-form__row--errorpop`;
        } else if (status === 1) {
            classes += ' registration-form__row--success';
        }

        return classes;
    };

    const continueStep = () => {
        if (checkAllStatuses()) {
            if (props.gtmRegistrationStartSent === false) {
                putDataIntoDataLayer({
                    event: 'registrationStart',
                    platform: props.isDesktop === true ? 'desktop' : 'mobile',
                });
            }

            const btagValue = getCookie(COOKIES.BTAG);

            if (btagValue !== '') {
                props.updateBtagAsSiteId({btag: btagValue});
            }

            props.validateStep1({
                email: props.emailData.value,
                firstName: props.firstNameData.value,
                lastName: props.surnameData.value,
                day: props.birthdayData.day,
                month: props.birthdayData.month,
                year: props.birthdayData.year,
            });
        }
    };

    const onBlurPromo = () => {
        if (props.promocodeData.value !== promocodeValue) {
            if (promocodeValue.length === 0) {
                props.resetPromocode();
            }

            if (promocodeValue.length > 2) {
                props.validatePromocode({promocode: promocodeValue});
            }
        }
    };

    const emailNotificationClass = getClassesByStatus(props.emailData.status);
    const firstnameNotificationClass = getClassesByStatus(props.firstNameData.status);
    const surnameNotificationClass = getClassesByStatus(props.surnameData.status);
    const birthdateNotificationClass = getClassesByStatus(props.birthdayData.status);
    const promocodeNotificationClass = getClassesByStatus(props.promocodeData.status);

    const sentGtmRegistrationFirstInteraction = () => {
        if (props.gtmRegistrationFirstInteractionSent === false) {

            putDataIntoDataLayer({
                event: 'registrationFirstInteraction',
                platform: props.isDesktop === true ? 'desktop' : 'mobile',
            });

            props.updateGtmRegistrationFirstInteractionSent();
        }
    }

    return (
        <form className="registration-form">

            <div className={`registration-form__row ${emailNotificationClass}`}>
                <label className="registration-form__label" htmlFor="email">Email</label>
                <input id="email" onBlur={checkEmail} className="registration-form__input" type="text"
                       value={emailValue}
                       onChange={e => onChangeEmail(e)}
                />
                <p className="registration-form__error">
                    <span className="registration-form__error-i pull-left mr5"/>
                    {props.emailData.message}
                </p>
                <p className="registration-form__info-bg">A valid email is required to register and withdraw funds.</p>
                <i className="registration-form__status icon-input-success"/>
                <i className="registration-form__status icon-input-error"/>
            </div>

            <div className={`registration-form__row ${firstnameNotificationClass}`}>
                <label className="registration-form__label" htmlFor="first-name">First Name</label>
                <input id="first-name" onBlur={getFirstNameValue}
                       className="registration-form__input" type="text"
                       value={firstNameValue}
                       onChange={e => onChangeFirstName(e)}
                />

                <p className="registration-form__error">
                    <span className="registration-form__error-i pull-left mr5"/>
                    {props.firstNameData.message}
                </p>
                <p className="registration-form__info-bg">Enter your First Name as it appears in your bank account.</p>
                <i className="registration-form__status icon-input-success"/>
                <i className="registration-form__status icon-input-error"/>
            </div>

            <div className={`registration-form__row ${surnameNotificationClass}`}>
                <label className="registration-form__label" htmlFor="last-name">Surname</label>
                <input id="last-name" onBlur={getSurnameValue}
                       className="registration-form__input" type="text"
                       value={surnameValue}
                       onChange={e => onChangeSurname(e)}
                />
                <p className="registration-form__error">
                    <span className="registration-form__error-i pull-left mr5"/>
                    {props.surnameData.message}
                </p>
                <p className="registration-form__info-bg">Enter your Surname as it appears in your bank account.</p>
                <i className="registration-form__status icon-input-success"/>
                <i className="registration-form__status icon-input-error"/>
            </div>

            <div className={`registration-form__row ${birthdateNotificationClass}`}>
                <label className="registration-form__label" htmlFor="day">Date of birth</label>
                <div className="d-f registration-form__row-dob">
                    <div className="registration-form__input-wrapper">
                        <input id="day"
                               className={`registration-form__input ${props.birthDayStatus === -1 ? 'error' : ''}`}
                               onBlur={getCalendarDay}
                               type="number"
                               placeholder="DD"
                               value={dayValue}
                               onChange={e => {
                                   sentGtmRegistrationFirstInteraction();
                                   setDayValue(e.target.value.trim().slice(0, 2).replace(/\s/g, ""))
                               }
                               }
                        />
                    </div>
                    <div className="registration-form__input-wrapper">
                        <input id="month"
                               className={`registration-form__input ${props.birthMonthStatus === -1 ? 'error' : ''}`}
                               onBlur={getCalendarMonth}
                               type="number"
                               placeholder="MM"
                               value={monthValue}
                               onChange={e => {
                                   sentGtmRegistrationFirstInteraction();
                                   setMonthValue(e.target.value.trim().slice(0, 2).replace(/\s/g, ""))
                               }
                               }
                        />
                    </div>
                    <div className="registration-form__input-wrapper">
                        <input id="year"
                               className={`registration-form__input ${props.birthYearStatus === -1 ? 'error' : ''}`}
                               onBlur={getCalendarYear}
                               type="number"
                               placeholder="YYYY"
                               value={yearValue}
                               onChange={(e) => {
                                   sentGtmRegistrationFirstInteraction();
                                   setYearValue(e.target.value.trim().slice(0, 4).replace(/\s/g, ""))
                               }
                               }
                        />
                    </div>
                </div>
                <p className="registration-form__error">
                    <span className="registration-form__error-i pull-left mr5"/>
                    {props.birthdayData.message}
                </p>
                <i className="registration-form__status icon-input-success"/>
                <i className="registration-form__status icon-input-error"/>
            </div>

            <div className={`registration-form__row ${promocodeNotificationClass}`}>
                <label className="registration-form__label" htmlFor="promo-code">Promotion Code (optional)</label>
                <input id="promo-code"
                       className="registration-form__input"
                       type="text"
                       value={promocodeValue}
                       onChange={e => {
                           setPromocodeValue(e.target.value.trim().replace(/\s/g, ""))
                       }
                       }
                       onBlur={onBlurPromo}
                />
                <p className="registration-form__error">
                    <span className="registration-form__error-i pull-left mr5"/>
                    {props.promocodeData.message}
                </p>
                <i className="registration-form__status icon-input-error"/>
            </div>

            <button type="button" title="Continue"
                    disabled={props.isLoading || !checkAllStatuses()}
                    className={`btn-primary-s registration-form__submit ${props.isLoading ? 'btn-loader' : ''}`}
                    onClick={() => continueStep()}
            >
                Continue
            </button>
        </form>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(FirstStep);
